import { AttachmentDto } from 'api/common/models/AttachmentDto';
import { ParameterSectionParameterType, ParameterSectionType, ParameterVisibility } from 'common/components/parametersSections/models';

export interface ElementDto {
    id: string;
    version: string;
    name: string;
    description?: string;
    reference?: string;
    referenceSage?: string;
    unitId?: string;
    price?: number;
    priceExpression?: string;
    taxId?: string;
    workTypeId?: string;
    elementTypeId?: string;
    images?: AttachmentDto[];
    imagesIds?: string [];
    attachment?: AttachmentDto;
    attachmentsToCopy?: string [];
    families?: FamilySelectModel[];
    budgetPdfVisibility: string;
    imagesToRemove: string[];
    mainImageKey?: string;
    deleteAttachment: boolean

    isElement: boolean;
    isComponent: boolean;
    parameters?: ElementParameterDto[]
}

export interface FamilySelectModel {
    id: string;
    key?: string;
    newRow?: boolean;
    familyId?: string | null;
    subFamilyId?: string | null;
    isComponent?: boolean;
    isElement?: boolean;
}

export interface ElementListDto {
    id: string;
    version: string;
    name: string;
    description?: string;
    reference?: string;
    referenceSage?: string;
    unitName?: string;
    unitSymbol?: string;
    unitId?: string;
    price?: number;
    taxId?: string;
    taxName?: string;
    taxValue?: number
    workTypeId?: string;
    workTypeName?: string;
    elementTypeId?: string;
    elementTypeName?: string;
    mediaUrl?: string;
    familyId?: string;
    familiesNames: string[];
    subFamilyId?: string;
    subFamiliesNames: string[];

    updatedDate?: Date | null;
    userUpdatedName?: string;

    priceToUpdate?: boolean;
}

export interface ElementParameterDto {
    id?: string;
    active?: boolean;
    familyParameterId?: string | null ;
    elementFamilyKey?: string;

    products?: ParameterProductLine[];
    minMax?: ParameterMinMax;
    images?: AttachmentDto[];
    text?: string | null;
    number?: number | null;
    quantity?: number | null;

    elementFamilyId?: string;

    title?: string | null;
    type?: ParameterSectionType;
    unitId?: string | null;
    unitSymbol?: string | null
    familyId?: string;
    familyName?: string;
    parameterType?: ParameterSectionParameterType | null;
    parameterName?: string | null;
    parameterFamilyId?: string | null;
    parameterIsRequired?: boolean;
    visibility?: ParameterVisibility;
    position?: number;

    supplierId?: string | null;
    supplierName?: string | null;
    dateValue?: string | null;
    price?: ParameterPrice | null;

    closed: boolean;

    key: string;
    parentKey: string | null;
    isOpen: boolean;
    isInCycle?: boolean;
    formulaExpression?: string | null;
    catalogParameterId?: string | null;
}

export interface ElementParameterTextDto {
    text?: string
}

export interface ElementParameterNumberDto {
    number?: number | null
}

export interface ParameterPrice {
    price?: number | null;
    unitId?: string | null;
    unitSymbol?: string | null;
}

export interface ParameterMinMax {
    minValue?: number | null;
    maxValue?: number | null;
    unitId?: string | null;
    products?: ParameterProductLine[]
}

export interface ParameterProductLine {
    id: string;
    checked?: boolean
    elementId?: string | null;
    quantity?: number | null;
    price?: number | null;
    unitId?: string | null;
    unitSymbol?: string | null;
    selectObject?: ProductSelectObject

    key: string;
    parentKey: string | null;
    isOpen: boolean;
}

export interface ProductSelectObject {
    label: string
    subTitle: string
    imageUrl: string;
    elementImageUrl: boolean;

}

export interface ParameterImage {
    attachmentId?: string;
    key?: string;
    isMain: boolean ;
    active: boolean;
}

export enum ElementHistoryReason {
    MANUAL_UPDATE = 0,
    BULK_PRICE_UPDATE = 1,
    EXPRESSION_RECALCULATION = 2,
    INITIAL_CREATION = 3,
    FAMILY_AVERAGE_RECALCULATION = 4,
    COEFFICIENT_RECALCULATION = 5,
    REFERENCED_ELEMENT_RECALCULATION = 6
}

export interface ElementHistoryDto {
    date: Date;
    userName: string;
    price: number;
    unit?: string;
    reason: ElementHistoryReason;
    referencedElementName?: string;
    referencedElementPrice?: number;
}

export interface ElementUpdatePricesDto {
    elementsIds: string[];
    priceVariationPercentage: number;
}

export enum BudgetPDFVisibility {
    ELEMENT_AND_PRICE_VISIBLE = 'ELEMENT_AND_PRICE_VISIBLE',
    PRICE_INVISIBLE = 'PRICE_INVISIBLE',
    ELEMENT_INVISIBLE = 'ELEMENT_INVISIBLE',
}
